import * as yup from 'yup'

export function yupSelectRequired(message) {
    return yup
        .object()
        .shape({ value: yup.mixed().required(message) })
        .required(message)
        .typeError(message)
}

export function parseCSV(csv, expectedHeaders) {
    const lines = csv.trim().split(/\r?\n/)
    if (lines.length <= 1)
        return {
            error: `No data to parse`,
        }

    // determine delimiter
    const columnSize = expectedHeaders.length
    let delimiter = ','
    let headers = lines[0].split(delimiter)
    if (headers.length !== columnSize) {
        delimiter = ';'
        headers = lines[0].split(delimiter)
        if (headers.length !== columnSize) {
            return {
                error: `Invalid data.`,
            }
        }
    }

    // check correct headers
    if ([...headers].sort().toString() !== expectedHeaders.sort().toString()) {
        return { error: `Invalid headers. Expected: ${expectedHeaders}` }
    }

    // add values to data array
    let data = []
    lines.slice(1).forEach(line => {
        let values = line.split(delimiter)
        let obj = {}
        headers.forEach((header, index) => (obj[header] = values[index]))
        data.push(obj)
    })
    return { data }
}
